import * as Immutable from 'immutable';

export type StoreVariantPayload = {
  id: number
  id_store_product: number
  external_id: string
  title: string
  id_product: number|null
  id_product_design: number|null
  ignored: boolean
  listOptions: number[]
}

interface IStoreVariantStore {
  id: number
  id_store_product: number
  external_id: string
  title: string
  id_product: number|null
  id_product_design: number|null
  ignored: boolean
  listOptions: Immutable.OrderedSet<number>
}

const defaultStoreVariantStore = Immutable.Record<IStoreVariantStore>({
  id: 0,
  id_store_product: 0,
  external_id: '',
  title: '',
  id_product: null,
  id_product_design: null,
  ignored: false,
  listOptions: Immutable.OrderedSet<number>(),
});

export class StoreVariantStore extends defaultStoreVariantStore implements IStoreVariantStore {}